import React from "react";
import http from "../../util/api";
import qs from "qs";
import moment from "moment";
import "./EditContent.scss";
import img1 from "./imgs/SHVO.png";
import img2 from "./imgs/doctor.png";
import { Toast, Button } from "antd-mobile";
import SignatureCanvas from "react-signature-canvas";
let timer;
class EditContent extends React.Component {
  state = {
    title: "",
    toWrite: "",
    signature: null,
    REC_ID: "",
    showSigPad: false,
    trimmedDataURL: "",
    h: window.innerHeight,
    w: window.innerWidth - 48,
    name: "",
    fund: "",
    stTime: "",
    edTime: "",
    theme: "",
    speech: "",
    job: "",
    service: "",
    cost: "",
    id: "",
    BC: "",
    date: "",
    check1: false,
    check2: false,
    check3: false,
    check4: false,
    canSub: false,
  };

  async componentDidMount() {
    const search = document.location.search;
    const querystring = search.substring(1);
    let id = qs.parse(querystring).id; //从url中取id
    Toast.loading("登录中，请稍后…");
    this.getToken();
    let myDateS = new Date();
    myDateS = moment(myDateS).format("YYYY-MM-DD");
    this.setState({ date: myDateS });
    this.getRec(id);
  }
  constructor(props) {
    super(props);
    this.clear = this.clear.bind(this);
    this.trim = this.trim.bind(this);
  }
  sigCanvas = {
    clear: () => {},
    toDataURL: (param) => {
      return "";
    },
  };
  clear() {
    this.sigCanvas.clear();
    this.setState({ signature: null, trimmedDataURL: "" });
  }
  trim() {
    this.setState({
      showSigPad: false,
      signature: this.sigCanvas.toDataURL("image/png"),
      trimmedDataURL: this.sigCanvas.toDataURL("image/png"),
    });
    //let trimmedCanvas = this.sigCanvas.getTrimmedCanvas();
  }
  getToken = async () => {
    let res;
    let url = { baseURL: window.liveUrl };
    try {
      res = await http(url).login({
        code: "public",
        password: "123456",
      });
      let str = JSON.stringify(res.data);
      localStorage.setItem("userInfo", str);
      // await this.addRec();
    } catch (e) {
      console.log(e.message);
      Toast.fail("登录失败");
    }
  };
  getRec = async (id) => {
    Toast.loading("获取数据中", 0);
    let res;
    let url = { baseURL: window.liveUrl };
    try {
      res = await http(url).getTable({
        resid: 641478617353,
        cmswhere: `REC_ID = '${id}'`,
      });
      if (res.data.data[0].signature_time) {
        this.setState({
          canSub: false,
          check1: true,
          check2: true,
          check3: true,
          check4: true,
        });
      } else {
        this.setState({ canSub: true });
      }
      this.setState({
        name: res.data.data[0].name,
        fund: res.data.data[0].client,
        stTime: res.data.data[0].starttime,
        edTime: res.data.data[0].endtime,
        theme: res.data.data[0].event_topic,
        speech: res.data.data[0].speech_topic,
        job: res.data.data[0].service_name,
        service: res.data.data[0].service_type,
        cost: res.data.data[0].amount,
        id: res.data.data[0].ID,
        BC: res.data.data[0].bank_count,
        date: res.data.data[0].signature_time,
        signature: res.data.data[0].base64Picture,
        trimmedDataURL: res.data.data[0].base64Picture,
        REC_ID: res.data.data[0].REC_ID,
      });
      Toast.hide();
    } catch (e) {
      console.log(e.message);
      Toast.fail("数据获取失败");
    }
  };
  addRec = async () => {
    let res;
    let url = { baseURL: window.liveUrl };
    try {
      res = await http(url).saveLive({
        resid: 641478617353,
        data: '[{"_id":1,"_state":"added"}]',
      });
      this.setState({
        REC_ID: res.data.data[0].REC_ID,
        toWrite: res.data.data[0].C3_641478671690,
        title: res.data.data[0].C3_641478661509,
      });
      Toast.hide();
    } catch (e) {
      console.log(e.message);
      Toast.fail("登录失败");
    }
  };

  //将base64转换为blob
  dataURLtoBlob = (dataurl) => {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };
  //将blob转换为file
  blobToFile = (theBlob, fileName) => {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  };
  //调用

  submit = async () => {
    if (
      this.state.check1 &&
      this.state.check2 &&
      this.state.check3 &&
      this.state.check4
    ) {
      let url = { baseURL: window.liveUrl };

      if (this.state.signature) {
        Toast.loading("正在提交");
        let myDate = new Date();
        myDate = moment(myDate).format("YYYY-MM-DD");
        let obj = {
          REC_ID: this.state.REC_ID,
          base64Picture: this.state.signature,
          //   name:'张三',
          //   client:'1000',
          //   starttime:'20200506',
          //   endtime:'20200509',
          //   event_topic:'禽类营养讲座',
          //   speech_topic:'鸡汤应该在餐前喝还是餐后喝',
          //   service_name:'厨师',
          //   service_type:'烹饪午餐',
          //   amount:'200',
          //  ID:'32019800808044X',
          //  bank_count:'1234567890ab',
          signature_time: myDate,
        };
        let res2 = await http(url).modifyRecords({
          resid: 641478617353,
          data: [obj],
        });
        this.setState({ canSub: false });
        Toast.success("提交成功");
      } else {
        Toast.fail("您还没有签名");
      }
    } else {
      Toast.fail("请勾选所有服务和工作内容！");
    }
  };
  render() {
    let { trimmedDataURL } = this.state;
    return (
      <div className="content_sig">
        <h3
          style={{
            lineHeight: "1.5rem",
            fontSize: "1rem",
            display: "block",
            color: "#333",
            textAlign: "center",
            paddingTop: "1rem",
            marginBottom: "1rem",
            width: "100vw",
          }}
        >
          服务确认书
        </h3>
        <p
          style={{
            fontSize: "1rem",
            textAlign: "left",
            width: "100vw",
            lineHeight: "1.5rem",
            padding: "0 1rem 1rem",
            boxSizing: "border-box",
          }}
        >
          {"尊敬的炎症性肠病患者"}:
        </p>
        <p
          style={{
            fontSize: "1rem",
            textAlign: "left",
            width: "100vw",
            lineHeight: "1.5rem",
            padding: "0 1rem 1rem",
            boxSizing: "border-box",
          }}
        >
          您好！
        </p>
        <p
          style={{
            fontSize: "1rem",
            textAlign: "left",
            width: "100vw",
            lineHeight: "1.5rem",
            padding: "0 1rem 1rem",
            boxSizing: "border-box",
          }}
        >
          我们诚挚地邀请您参与《中国炎症性肠病患者及医生疾病认知差异的横断面研究》。
          本研究的主要目的是了解患者与专科医生在疾病症状、治疗等方面的认知差异，探究医患关系对患者生活质量及依从性的影响。
          研究成果将增进中国医务人员对炎症性肠病患者的了解，促进医患沟通，最终提高医疗质量。
        </p>

        <p
          style={{
            fontSize: "1rem",
            textAlign: "left",
            width: "100vw",
            lineHeight: "1.5rem",
            padding: "0 1rem 1rem",
            boxSizing: "border-box",
          }}
        >
          现特邀请您填写一份问卷，大约需要占用您20-30分钟时间。
        </p>
        <p
          style={{
            fontSize: "1rem",
            textAlign: "left",
            width: "100vw",
            lineHeight: "1.5rem",
            padding: "0 1rem 1rem",
            boxSizing: "border-box",
          }}
        >
          我们承诺对您的个人资料绝对保密。本研究不会对您带来任何风险或伤害，是否参与研究不影响您接受的医疗服务。您将自主决定是否参加本研究，并可以在研究进行的任何阶段退出（资料立即销毁）。
        </p>
        <p
          style={{
            fontSize: "1rem",
            textAlign: "left",
            width: "100vw",
            lineHeight: "1.5rem",
            padding: "0 1rem 1rem",
            boxSizing: "border-box",
          }}
        >
          如果您对于本研究有任何疑问，或在问卷提交后需要退出研究，请及时联系我们。联系人：汤必华
          电子邮箱：chaseibd_service@163.com 微信号：days_run
          固定电话：(+86)15821206771
        </p>
        {/* <p>
          <b style={{ border: "none", fontWeight: "bold" }}>
            您的签署或盖章即表明对与上海大億宝信息科技有限公司建立此次劳务关系的确认。
          </b>
        </p> */}
        <p
          style={{
            fontSize: "1rem",
            textAlign: "left",
            width: "100vw",
            lineHeight: "1.5rem",
            padding: "0 1rem 1rem",
            boxSizing: "border-box",
          }}
        >
          衷心感谢您的参与和配合！
        </p>

        <p>签名：</p>
        {!this.state.signature ? (
          <>
            <div
              className="blank"
              onClick={() => {
                this.setState({ showSigPad: true });
              }}
            >
              点击开始签名
            </div>
          </>
        ) : (
          <>
            <img
              ref="img"
              style={{ maxHeight: "calc(100vh - 14rem)" }}
              onClick={() => {
                if (this.state.canSub) {
                  this.setState({ showSigPad: true });
                }
              }}
              src={this.state.signature}
            />
          </>
        )}
        <div className="btnLine">
          {this.state.canSub ? (
            <Button
              type="primary"
              className="submit"
              onClick={() => {
                this.submit();
              }}
            >
              提交
            </Button>
          ) : null}
        </div>
        <div className={this.state.showSigPad ? "sigPad" : "hidden"}>
          <div className="titleLine">
            <Button
              size="small"
              type="primary"
              onClick={() => {
                this.trim();
              }}
            >
              确定
            </Button>
            <Button
              size="small"
              onClick={() => {
                this.setState({ showSigPad: false });
              }}
            >
              取消
            </Button>
            <Button
              size="small"
              style={{ float: "left" }}
              onClick={() => {
                this.clear();
              }}
            >
              清空
            </Button>
          </div>
          <div className="paper">
            <SignatureCanvas
              penColor="green"
              canvasProps={{
                width: this.state.w,
                height: this.state.h,
                className: "sigCanvas",
              }}
              ref={(ref) => {
                this.sigCanvas = ref;
              }}
            />
          </div>
        </div>
        <div className="imgLine">
          <img src={img1} />
          <img src={img2} />
        </div>
      </div>
    );
  }
}

export default EditContent;
